export enum RecentActivityType {
	AddProduct,
	AddWardrobeItem,
	AddArticle,
	FollowUser,
	LikeArticle,
	LikeProduct,
	AddWishlistProduct,
	AddWishlistWardrobeItem,
	AddOutfit,
}
